import * as yup from "yup";

export const ScheduleDateSchema = yup.object().shape({
  selectedDate: yup
    .string()
    .required("La fecha es requerida"),
  shift: yup
    .number()
    .min(0, "Campo turno es requerido")
    .required("Campo requerido")
    .integer("Campo requerido"),
  dayOfWeek: yup
    .number()
    .min(0, "Campo día es requerido")
    .required("Campo requerido")
    .integer("Campo requerido"),
});

